import {default as DocumentScanner} from '@mui/icons-material/DocumentScanner';
import {default as History} from '@mui/icons-material/History';
import {default as Flaky} from '@mui/icons-material/Flaky';
import {default as DynamicFeed} from '@mui/icons-material/DynamicFeed';
import {default as FolderCopy} from '@mui/icons-material/FolderCopy';
import {fetchDownloadFile} from "./FileUtils";
import {ReactElement} from 'react';

export const ActionTypes = Object.freeze({
  DOWNLOAD: 'DOWNLOAD',
  OPEN_TAB: 'OPEN_TAB',
  DIALOG: 'DIALOG',
  POST_REQUEST: 'POST_REQUEST',
  HANDLER: 'HANDLER',
} as const);

export type ActionType = typeof ActionTypes[keyof typeof ActionTypes];

export const ActionDefaultIcons: Record<ActionType, ReactElement<any>> = Object.freeze({
  [ActionTypes.DOWNLOAD]: <DocumentScanner/>,
  [ActionTypes.OPEN_TAB]: <FolderCopy/>,
  [ActionTypes.DIALOG]: <DynamicFeed/>,
  [ActionTypes.POST_REQUEST]: <Flaky/>,
  [ActionTypes.HANDLER]: <History/>,
});

export const CallbackActions = Object.freeze({
  SUCCESS: 'SUCCESS',
  OPEN_DIALOG: 'OPEN_DIALOG',
  ERROR: 'ERROR',
  LOGOUT: 'LOGOUT',
  POST_REQUEST: 'POST_REQUEST',
} as const);

export type CallbackAction = typeof CallbackActions[keyof typeof CallbackActions];

interface ActionPayload<T = unknown> {
  endpoint: (instrument: T) => string;
  successMessage?: string;
  errorMessage?: string;
}

type OnActionCallback = (action: CallbackAction, instrument: unknown, successMessage?: string, errorMessage?: string) => void;

export const executeDownload = <T = unknown>(
  instrument: T,
  actionPayload: ActionPayload<T>,
  onAction?: OnActionCallback
): void => {
  const onError = onAction
    ? () => {
      onAction(CallbackActions.ERROR, instrument, actionPayload.errorMessage);
      return {};
    }
    : () => ({});

  const onSuccess = onAction
    ? () => {
      onAction(CallbackActions.SUCCESS, instrument, actionPayload.successMessage || '');
      return {};
    }
    : () => ({});

  fetchDownloadFile(
    actionPayload.endpoint(instrument),
    onSuccess,
    onError,
  );
};

export const executeOpenTab = <T = unknown>(
  instrument: T,
  actionPayload: ActionPayload<T>,
  onAction?: OnActionCallback
): void => {
  try {
    window.open(actionPayload.endpoint(instrument));
  } catch {
    if (onAction) {
      onAction(CallbackActions.ERROR, instrument, actionPayload.errorMessage);
    }
  }
};